import { render, staticRenderFns } from "./SolutionSearchMenu.vue?vue&type=template&id=66a69b50"
import script from "./SolutionSearchMenu.vue?vue&type=script&lang=js"
export * from "./SolutionSearchMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports